import PartnerProductView from "./PartnerProductView";

export default PartnerProductView;
